import common from './common'
import { REPORT_PARAMS, SDK_PRODUCT } from '@/config/dataMap'
const vip_version = REPORT_PARAMS.vip_version
const show_from = REPORT_PARAMS.show_from

/** 退出vip页面漏斗数据回收 */
const quitRetainUsers = 'duba_jgpdf_coupon:7431 showed:int clicked:int show_from:int64 productid:int ver:int abtest:int login_type:int openid:string'

export default {
  API: {
    method1 () {
    }
  },
  REPORT: {

    /** 退出挽留用户 */
    reportQuitRetainUsers (params) {
      const info = {
        showed: 0, // 0-数值为空 1、支付页面 2、优惠券弹窗 3、优惠券支付页面
        clicked: 0, // 0-数值为空 1、关闭支付页面 2、关闭优惠券弹窗 3、关闭优惠券支付页面 4、点击优惠券弹窗 5、点击优惠券
        show_from: show_from || 0, // 客户端来源
        productid: SDK_PRODUCT.id,
        ver: vip_version, // 版本号
        login_type: 0, // 是否登录
        openid: 0, // 用户openid
        abtest: 0, // 1 使用优惠券 2 不使用优惠券 （根据用户openid最后一位数为 奇(打开1) 偶/0(不打开2) ）
      }
      return common.REPORT.client_report_by_kfmt(quitRetainUsers, common.API.replaceObj(info, params))
    }

  }
}
